import React from "react";
import { Section } from "../shared";
import PlatformTabs from "./PlatformTabs";
import SkillInstructions from "./SkillInstructions";
import TestPrompts from "./TestPrompts";

const PLATFORMS = [
  { name: "Claude Desktop", status: "supported", icon: "✓" },
  { name: "Claude Code", status: "supported", icon: "✓" },
  { name: "VS Code Copilot", status: "supported", note: "Agent mode", icon: "✓" },
  { name: "Cursor", status: "supported", icon: "✓" },
  { name: "Windsurf", status: "supported", icon: "✓" },
  { name: "Codex", status: "supported", icon: "✓" },
  { name: "OpenCode", status: "supported", icon: "✓" },
  { name: "ChatGPT", status: "partial", note: "Via Custom GPT Action", icon: "⚠" },
];

export default function SetupSection({ latestKey }) {
  return (
    <Section
      title="Setup Guide"
      subtitle="Connect your AI agent to Horus Wallet"
      id="mcp-setup"
    >
      {/* Step 1: Platform connection */}
      <h5 className="mcp-subsection-title">Step 1: Connect your AI agent</h5>
      <PlatformTabs latestKey={latestKey} />

      {/* Step 2: Skill */}
      <SkillInstructions />

      {/* Step 3: Test */}
      <TestPrompts />

      {/* Supported platforms grid */}
      <div className="mcp-platforms-grid">
        <h5 className="mcp-subsection-title">Supported platforms</h5>
        <div className="mcp-platform-cards">
          {PLATFORMS.map((p) => (
            <div
              key={p.name}
              className={`mcp-platform-card ${
                p.status === "partial" ? "mcp-platform-partial" : ""
              }`}
            >
              <span
                className={`mcp-platform-icon ${
                  p.status === "supported"
                    ? "mcp-platform-check"
                    : "mcp-platform-warn"
                }`}
              >
                {p.icon}
              </span>
              <span className="mcp-platform-name">{p.name}</span>
              {p.note && (
                <span className="mcp-platform-note">{p.note}</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}
